"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _bodyScrollLock = require("body-scroll-lock");
var _Container = _interopRequireDefault(require("./Container"));
var _Text = _interopRequireDefault(require("./Text"));
var _EmptyButton = _interopRequireDefault(require("./EmptyButton"));
var _Icon = _interopRequireDefault(require("./Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};
let timeout;
let touchMoveTimeout;
let prevPageX;
let prevPageY;
let directionX;
let directionY;
const translate = (mode, value) => mode === 'desktop' ? `translateX(-${value})` : `translateY(${value})`;
const slideIn = mode => (0, _styledComponents.keyframes)(["from{transform:", ";}to{transform:", ";}"], translate(mode, '100%'), translate(mode, '0'));
const slideOut = mode => (0, _styledComponents.keyframes)(["from{transform:", ";}to{transform:", ";}"], translate(mode, '0'), translate(mode, '100%'));
const fadeIn = (0, _styledComponents.keyframes)(["from{opacity:0;}to{opacity:1;}"]);
const fadeOut = (0, _styledComponents.keyframes)(["from{opacity:1;}to{opacity:0;}"]);
const slideAnimation = ({
  hide,
  animationDuration,
  mode
}) => (0, _styledComponents.css)(["", " ", "ms"], hide ? slideOut(mode) : slideIn(mode), animationDuration);
const fadeAnimation = ({
  hide,
  animationDuration
}) => (0, _styledComponents.css)(["", " ", "ms"], hide ? fadeOut : fadeIn, animationDuration);
const AnimationContainer = (0, _styledComponents.default)(_Container.default).withConfig({
  displayName: "NotificationSlider__AnimationContainer",
  componentId: "sc-a05jum-0"
})(["animation:", ";transform:", ";"], slideAnimation, props => props.hide ? translate(props.mode, '100%') : translate(props.mode, '0'));
const AnimationButton = (0, _styledComponents.default)(_EmptyButton.default).withConfig({
  displayName: "NotificationSlider__AnimationButton",
  componentId: "sc-a05jum-1"
})(["animation:", ";opacity:", ";"], fadeAnimation, props => props.hide ? '0' : '1');
const NotificationSlider = ({
  show,
  duration,
  animationDuration,
  children,
  icon,
  heading,
  text,
  onClose,
  mode,
  zIndex,
  ...props
}) => {
  const [inDom, setInDom] = (0, _react.useState)(false);
  const enableScroll = () => {
    const elm = document.querySelector('.NotificationSlider__container');
    if (elm) {
      (0, _bodyScrollLock.enableBodyScroll)(elm);
    }
  };
  const disableScroll = () => {
    const elm = document.querySelector('.NotificationSlider__container');
    if (elm) {
      (0, _bodyScrollLock.disableBodyScroll)(elm);
    }
  };
  const close = (0, _react.useCallback)(() => {
    enableScroll();
    clearTimeout(timeout);
    onClose();
  }, [onClose]);
  const startTimer = (0, _react.useCallback)(() => {
    timeout = setTimeout(close, duration);
  }, [close, duration]);
  (0, _react.useEffect)(() => {
    if (show && !inDom) {
      setInDom(true);
      startTimer();
    }
    if (!show && inDom) {
      setTimeout(() => {
        enableScroll();
        setInDom(false);
      }, animationDuration);
    }
  }, [show, animationDuration, startTimer, inDom, mode]);
  (0, _react.useEffect)(() => {
    if (inDom && mode !== 'desktop') {
      disableScroll();
    }
  }, [inDom, mode]);
  (0, _react.useEffect)(() => () => {
    (0, _bodyScrollLock.clearAllBodyScrollLocks)();
  }, []);
  const onTouchMove = e => {
    const {
      touches: [touch]
    } = e;
    const {
      pageX,
      pageY
    } = touch;
    if (touchMoveTimeout) {
      return;
    }
    touchMoveTimeout = setTimeout(() => {
      if (prevPageX) {
        const distanceX = pageX - prevPageX;
        const distanceY = pageY - prevPageY;
        directionX = distanceX < 0 ? 'right' : 'left';
        directionY = distanceY < 0 ? 'down' : 'up';
      }
      prevPageX = pageX;
      prevPageY = pageY;
      touchMoveTimeout = null;
    }, 10);
  };
  const onTouchEnd = () => {
    if (mode === 'desktop' && directionX === 'right') {
      close();
    }
    if (mode !== 'desktop' && directionY === 'up') {
      close();
    }
  };
  const defaultRender = () => /*#__PURE__*/_react.default.createElement(_Container.default, {
    display: "flex",
    flexDirection: mode === 'desktop' ? 'row' : 'column',
    alignItems: "center"
  }, icon ? /*#__PURE__*/_react.default.createElement(_Container.default, {
    maxWidth: mode === 'desktop' ? '130px' : 'unset'
  }, icon) : null, /*#__PURE__*/_react.default.createElement(_Container.default, {
    flex: "1",
    padding: mode === 'desktop' ? '20px 0 20px 20px' : '20px 0',
    alignItems: "center"
  }, heading ? /*#__PURE__*/_react.default.createElement(_Text.default, {
    display: "block",
    fontSize: mode === 'desktop' ? '16px' : '18px',
    fontWeight: "600",
    color: "normal",
    marginBottom: "12px",
    lineHeight: "1.3",
    textAlign: mode === 'desktop' ? 'left' : 'center'
  }, heading) : null, text ? /*#__PURE__*/_react.default.createElement(_Text.default, {
    fontSize: mode === 'desktop' ? '14px' : '16px',
    color: "text400",
    lineHeight: "1.4",
    display: "block",
    textAlign: mode === 'desktop' ? 'left' : 'center'
  }, text) : null), mode === 'desktop' && /*#__PURE__*/_react.default.createElement(_Container.default, {
    marginBottom: "auto"
  }, /*#__PURE__*/_react.default.createElement(_EmptyButton.default, {
    padding: "5px",
    onClick: close
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    iconSize: "medium",
    className: "ls-icon icon-generalxlarge"
  }))));
  if (!inDom) return null;
  return /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement(_Container.default, {
    zIndex: zIndex,
    position: "relative",
    onTouchMove: onTouchMove,
    onTouchEnd: onTouchEnd
  }, mode !== 'desktop' && /*#__PURE__*/_react.default.createElement(AnimationButton, {
    onClick: close,
    position: "fixed",
    left: "0",
    top: "0",
    right: "0",
    bottom: "0",
    backgroundColor: "rgba(0,0,0,0.5)",
    width: "100%",
    height: "100%",
    animationDuration: animationDuration,
    hide: !show
  }), /*#__PURE__*/_react.default.createElement(AnimationContainer, _extends({
    position: "fixed",
    padding: mode === 'desktop' ? '20px' : '0',
    maxWidth: mode === 'desktop' ? '465px' : 'unset',
    width: "100%",
    left: "0",
    bottom: "0",
    hide: !show,
    animationDuration: animationDuration,
    mode: mode
  }, props), /*#__PURE__*/_react.default.createElement(_Container.default, {
    width: "100%",
    backgroundColor: "white",
    borderRadius: mode === 'desktop' ? '10px' : '27px',
    borderBottomLeftRadius: mode === 'desktop' ? '10px' : '0',
    borderBottomRightRadius: mode === 'desktop' ? '10px' : '0',
    padding: mode === 'desktop' ? '0' : '0 30px 30px 30px',
    boxShadow: "0 0 20px 0 rgba(0, 0, 0, 0.2)",
    className: "NotificationSlider__container"
  }, children || defaultRender()))), document.body);
};
__signature__(NotificationSlider, "useState{[inDom, setInDom](false)}\nuseCallback{close}\nuseCallback{startTimer}\nuseEffect{}\nuseEffect{}\nuseEffect{}");
NotificationSlider.propTypes = {
  show: _propTypes.default.bool,
  duration: _propTypes.default.number,
  animationDuration: _propTypes.default.number,
  children: _propTypes.default.node,
  icon: _propTypes.default.node,
  heading: _propTypes.default.string,
  text: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  onClose: _propTypes.default.func,
  mode: _propTypes.default.string,
  zIndex: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
NotificationSlider.defaultProps = {
  show: false,
  duration: 6000,
  animationDuration: 500,
  children: null,
  icon: null,
  heading: null,
  text: null,
  onClose: () => {},
  mode: 'desktop',
  zIndex: 9
};
const _default = NotificationSlider;
var _default2 = exports.default = _default;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(timeout, "timeout", "/Users/jake.clayton/frontend/ls-common-client/src/components/NotificationSlider.js");
  reactHotLoader.register(touchMoveTimeout, "touchMoveTimeout", "/Users/jake.clayton/frontend/ls-common-client/src/components/NotificationSlider.js");
  reactHotLoader.register(prevPageX, "prevPageX", "/Users/jake.clayton/frontend/ls-common-client/src/components/NotificationSlider.js");
  reactHotLoader.register(prevPageY, "prevPageY", "/Users/jake.clayton/frontend/ls-common-client/src/components/NotificationSlider.js");
  reactHotLoader.register(directionX, "directionX", "/Users/jake.clayton/frontend/ls-common-client/src/components/NotificationSlider.js");
  reactHotLoader.register(directionY, "directionY", "/Users/jake.clayton/frontend/ls-common-client/src/components/NotificationSlider.js");
  reactHotLoader.register(translate, "translate", "/Users/jake.clayton/frontend/ls-common-client/src/components/NotificationSlider.js");
  reactHotLoader.register(slideIn, "slideIn", "/Users/jake.clayton/frontend/ls-common-client/src/components/NotificationSlider.js");
  reactHotLoader.register(slideOut, "slideOut", "/Users/jake.clayton/frontend/ls-common-client/src/components/NotificationSlider.js");
  reactHotLoader.register(fadeIn, "fadeIn", "/Users/jake.clayton/frontend/ls-common-client/src/components/NotificationSlider.js");
  reactHotLoader.register(fadeOut, "fadeOut", "/Users/jake.clayton/frontend/ls-common-client/src/components/NotificationSlider.js");
  reactHotLoader.register(slideAnimation, "slideAnimation", "/Users/jake.clayton/frontend/ls-common-client/src/components/NotificationSlider.js");
  reactHotLoader.register(fadeAnimation, "fadeAnimation", "/Users/jake.clayton/frontend/ls-common-client/src/components/NotificationSlider.js");
  reactHotLoader.register(AnimationContainer, "AnimationContainer", "/Users/jake.clayton/frontend/ls-common-client/src/components/NotificationSlider.js");
  reactHotLoader.register(AnimationButton, "AnimationButton", "/Users/jake.clayton/frontend/ls-common-client/src/components/NotificationSlider.js");
  reactHotLoader.register(NotificationSlider, "NotificationSlider", "/Users/jake.clayton/frontend/ls-common-client/src/components/NotificationSlider.js");
  reactHotLoader.register(_default, "default", "/Users/jake.clayton/frontend/ls-common-client/src/components/NotificationSlider.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();